module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_popout_small-c7c0f0b745111ff70be7c721ca8d5ed7.png";